/**
 * Created by andrey on 18.08.2025
 */

const Map2dCellPool = function (map2d, layerView) {
    Map2dPool.prototype.constructor.call(this, map2d);

    this.layerView = layerView;
};

Map2dCellPool.prototype = Object.create(Map2dPool.prototype);
Map2dCellPool.prototype.constructor = Map2dCellPool;

Map2dCellPool.prototype.add = function (x, y, view) {
    view.setVisible(false);
    Map2dPool.prototype.add.call(this, x, y, view);
};

Map2dCellPool.prototype.getFromPool = function (x, y) {
    let cellView = this.get(x, y);

    if (cellView) {
        this.remove(x, y);
        // cc.Base.PerformRecursive(cellView, (node) => {
        //     node.setNodeDirty();
        // });
    } else {
        cellView = new cc.Node();
        cellView.cellView = true;
        cellView.cell = { x, y };
        this.layerView.addChild(cellView);
    }

    return cellView;
};

Map2dCellPool.prototype.update = function () {
    const map2d = this.map2d;

    if (map2d.lastScrollTime + 500 > cleverapps.timeouts.time || this.size === 0) {
        return;
    }

    const now = Date.now();
    const start = now;
    const updateTime = this.updateTime || 0;
    const needUpdate = cc.renderer.childrenOrderDirty || updateTime + 100 < now;

    if (!needUpdate) {
        return;
    }

    this.updateTime = start;

    this.cleanUp();
};

Map2dCellPool.prototype.cleanUp = function (force = false) {
    const map2d = this.map2d;
    const batchSize = 100;
    const toRemove = [];

    for (const y in this.data) {
        for (const x in this.data[y]) {
            if (!force && !map2d.canHideTile(+x, +y)) {
                map2d.showTile(+x, +y);
                continue;
            }

            toRemove.push(this.data[y][x]);

            this.remove(x, y);

            if (toRemove.length >= batchSize && !force) {
                break;
            }
        }
    }

    if (toRemove.length > 0) {
        this.layerView.cleanupCellViews(toRemove);
    }
};
